module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_9006.207b00e4.png";